module.exports = __webpack_public_path__ + "static/img/avatar_bg.f3ab410e.png";